import {IJobCategory} from "./i-job-category";

export class JobCategory {
    public constructor(public label: string) {
    }

    public static fromInterface(iJobCategory: IJobCategory): JobCategory {
        return new JobCategory(iJobCategory.label);
    }
}
